
// import React, { useRef } from "react";
// import { motion, useInView } from "framer-motion";

// function HighReliabilityIndustries() {
//   const features = [
//     {
//       title: "Compliant and Audit Ready",
//       description:
//         "Highly regulated industries need a learning management system (LMS) to ensure all employee requirements are up-to-date and prepared for planned and unplanned audits.",
//       color: "#1E88E5",
      
//     },
//     {
//       title: "Continuous Accessible Learning",
//       description:
//         "High-reliability organisations emphasize continuous learning that is always available to keep workers equipped with the latest safety-critical protocols, procedures, and skill development.",
//       color: "#43A047",
       
//     },
//     {
//       title: "Tracking, Transparency and Reporting",
//       description:
//         "Training is a leading safety indicator; organizations need to monitor worker progress to identify knowledge gaps, structure learning programs, and assure capable workers are available for assignment.",
//       color: "#FB8C00",
       
//     },
//     {
//       title: "Incident Response",
//       description:
//         "In the event of an incident or policy change, an LMS can be used to quickly distribute training and new procedures throughout the organization to prevent incidents and keep workers safe.",
//       color: "#8E24AA",
       
//     },
//     {
//       title: "Resilience and Change Readiness",
//       description:
//         "A learning management system helps cultivate a culture of adaptability and resilience, which is crucial for responding to unforeseen changes.",
//       color: "#00ACC1",
       
//     },
//     {
//       title: "Additional Benefit",
//       description:
//         "An LMS provides centralized management of all training activities, ensuring consistency in messaging and compliance across the entire organization.",
//       color: "#F4511E",
       
//     },
//   ];

//   // Ref and inView hook for the container
//   const ref = useRef(null);
//   const isInView = useInView(ref, { once: true, amount: 0.1 });

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2,
//       },
//     },
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 50 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.6,
//         ease: "easeOut",
//       },
//     },
//   };

//   const styles = {
//     container: {
//       padding: "clamp(60px, 8vw, 80px) 20px",
//       textAlign: "center",
//       background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//       fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//       minHeight: "100vh",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "center",
//     },
//     heading: {
//       fontSize: "32px",
//       marginBottom: "16px",
//       fontWeight: "650",
//       color: "#1a202c",
//       letterSpacing: "-0.5px",
//       lineHeight: "1.2",
//       maxWidth: "900px",
//     },
//     subheading: {
//       fontSize: "clamp(16px, 3vw, 20px)",
//       marginBottom: "clamp(40px, 6vw, 60px)",
//       color: "black",
//       maxWidth: "1200px",
//       margin: "0 auto clamp(40px, 6vw, 60px)",
       
//       padding: "0 15px",
       
//     },
//     grid: {
//       display: "grid",
//       gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 350px), 1fr))",
//       gap: "clamp(24px, 4vw, 32px)",
//       maxWidth: "1200px",
//       margin: "0 auto",
//       width: "100%",
//       padding: "0 20px",
//     },
//     card: {
//       background: "#ffffff",
//       borderRadius: "16px",
//       boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.04)",
//       padding: "32px 28px",
//       textAlign: "left",
//       transition: "all 0.3s ease",
//       borderLeft: `6px solid`,
//       minHeight: "200px",
//       cursor: "pointer",
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "space-between",
//       position: "relative",
//       overflow: "hidden",
//     },
//     iconContainer: {
//       position: "absolute",
//       top: "20px",
//       right: "20px",
//       fontSize: "32px",
//       opacity: "0.1",
//     },
//     title: {
//       fontSize: "20px",
//       fontWeight: "600",
//       marginBottom: "16px",
//       color: "#2d3748",
//       lineHeight: "1.4",
//       position: "relative",
//       zIndex: 2,
//     },
//     desc: {
//       fontSize: "16px",
//       lineHeight: "1.6",
//       color: "#4a5568",
//       textAlign: "left",
//       position: "relative",
//       zIndex: 2,
//     },
//   };

//   return (
//     <div style={styles.container} ref={ref}>
//       <motion.h2
//         style={styles.heading}
//         initial={{ opacity: 0, y: -30 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true, amount: 0.5 }}
//         transition={{ duration: 0.8, ease: "easeOut" }}
//       >
//         Six Reasons Why High-Reliability Industries Need a Learning Management System
//       </motion.h2>
      
//       <motion.p 
//         style={styles.subheading}
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 1 }}
//         viewport={{ once: true, amount: 0.5 }}
//         transition={{ duration: 0.8, delay: 0.3 }}
//       >
//         Discover how an LMS ensures compliance, enhances safety, and builds resilience in high-stakes environments
//       </motion.p>

//       <motion.div
//         style={styles.grid}
//         variants={containerVariants}
//         initial="hidden"
//         animate={isInView ? "visible" : "hidden"}
//       >
//         {features.map((feature, index) => (
//           <motion.div
//             key={index}
//             variants={cardVariants}
//             style={{
//               ...styles.card,
//               borderLeftColor: feature.color,
//             }}
//             whileHover={{
//               y: -8,
//               boxShadow: "0 12px 28px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)",
//               transition: { duration: 0.3 },
//             }}
//           >
//             <div style={styles.iconContainer}>
//               {feature.icon}
//             </div>
//             <div>
//               <h3 style={styles.title}>{feature.title}</h3>
//               <p style={styles.desc}>{feature.description}</p>
//             </div>
//           </motion.div>
//         ))}
//       </motion.div>
//     </div>
//   );
// }

// export default HighReliabilityIndustries;


import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

function HighReliabilityIndustries() {
  const features = [
    {
      title: "Compliant and Audit Ready",
      description:
        "Highly regulated industries need a learning management system (LMS) to ensure all employee requirements are up-to-date and prepared for planned and unplanned audits.",
      color: "#1E88E5",
       
    },
    {
      title: "Continuous Accessible Learning",
      description:
        "High-reliability organisations emphasize continuous learning that is always available to keep workers equipped with the latest safety-critical protocols, procedures, and skill development.",
      color: "#43A047",
      
    },
    {
      title: "Tracking, Transparency and Reporting",
      description:
        "Training is a leading safety indicator; organizations need to monitor worker progress to identify knowledge gaps, structure learning programs, and assure capable workers are available for assignment.",
      color: "#FB8C00",
     
    },
    {
      title: "Incident Response",
      description:
        "In the event of an incident or policy change, an LMS can be used to quickly distribute training and new procedures throughout the organization to prevent incidents and keep workers safe.",
      color: "#8E24AA",
      
    },
    {
      title: "Resilience and Change Readiness",
      description:
        "A learning management system helps cultivate a culture of adaptability and resilience, which is crucial for responding to unforeseen changes.",
      color: "#00ACC1",
      
    },
    {
      title: "Additional Benefit",
      description:
        "An LMS provides centralized management of all training activities, ensuring consistency in messaging and compliance across the entire organization.",
      color: "#F4511E",
       
    },
  ];

  // Ref and inView hook for the container
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.1 });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const styles = {
    container: {
      padding: "clamp(40px, 6vw, 60px) 20px",
      textAlign: "center",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      fontFamily: "'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      minHeight: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    heading: {
      fontSize: "clamp(28px, 4vw, 36px)",
      marginBottom: "16px",
      fontWeight: "700",
      color: "#1a202c",
      letterSpacing: "-0.5px",
      lineHeight: "1.3",
      maxWidth: "900px",
      padding: "0 20px",
    },
    subheading: {
      fontSize: "clamp(16px, 2.5vw, 18px)",
      marginBottom: "clamp(30px, 5vw, 50px)",
      color: "#4a5568",
      maxWidth: "800px",
      margin: "0 auto clamp(30px, 5vw, 50px)",
      padding: "0 20px",
      lineHeight: "1.5",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 1fr))",
      gap: "clamp(20px, 3vw, 28px)",
      maxWidth: "1200px",
      margin: "0 auto",
      width: "100%",
      padding: "0 20px",
    },
    card: {
      background: "#ffffff",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.03)",
      padding: "24px 20px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: `5px solid`,
      minHeight: "220px",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      overflow: "hidden",
    },
    iconContainer: {
      position: "absolute",
      top: "16px",
      right: "16px",
      fontSize: "28px",
      opacity: "0.15",
      zIndex: 1,
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "12px",
      color: "#2d3748",
      lineHeight: "1.4",
      position: "relative",
      zIndex: 2,
      paddingRight: "40px",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.5",
      color: "#4a5568",
      textAlign: "left",
      position: "relative",
      zIndex: 2,
    },
  };

  return (
    <div style={styles.container} ref={ref}>
      <motion.h2
        style={styles.heading}
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        Six Reasons Why High-Reliability Industries Need a Learning Management System
      </motion.h2>
      
      <motion.p 
        style={styles.subheading}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.8, delay: 0.3 }}
      >
        Discover how an LMS ensures compliance, enhances safety, and builds resilience in high-stakes environments
      </motion.p>

      <motion.div
        style={styles.grid}
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            style={{
              ...styles.card,
              borderLeftColor: feature.color,
            }}
            whileHover={{
              y: -6,
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.06)",
              transition: { duration: 0.3 },
            }}
          >
            <div style={styles.iconContainer}>
              {feature.icon}
            </div>
            <div>
              <h3 style={styles.title}>{feature.title}</h3>
              <p style={styles.desc}>{feature.description}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
     <div style={{ textAlign: "center" }}>
  <a
    href="https://iiautomate.com/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      textDecoration: "none",
    }}
  >
    <button
      style={{
        backgroundColor: "#0d7a93",
        color: "#ffffff",
        border: "none",
        padding: "12px 28px",
        borderRadius: "8px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        marginTop: "40px",
      }}
    >
      Visit Our Website
    </button>
  </a>
</div>

    </div>
  );
}

export default HighReliabilityIndustries;